// choose the fields you actually want to persist

import { TeamMember } from 'types'

const pickTeamMember = (u: any): TeamMember | null => {
  if (!u) return null
  const id = u.user_uuid ?? u.id
  if (!id) return null
  return {
    user_uuid: id,
    name: u.name ?? u.real_name ?? '',
    email: u.email ?? '',
    image_512: u.image_512 ?? u.avatar ?? '',
    role: u.role ?? '',
  }
}

// Accept either an array of IDs or an array of user objects
export const normalizeTeam = (value: any[], usersIndex?: Map<string, any>): TeamMember[] => {
  const out: TeamMember[] = []
  for (const v of value ?? []) {
    if (typeof v === 'string') {
      // id → lookup from index
      const user = usersIndex?.get(v)
      const item = pickTeamMember(user)
      if (item) out.push(item)
    } else {
      // object → normalize directly
      const item = pickTeamMember(v)
      if (item) out.push(item)
    }
  }
  // dedupe
  const seen = new Set<string>()
  return out.filter(t => !seen.has(t.user_uuid) && seen.add(t.user_uuid))
}
